import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { user } from '../_models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  public token: string = null;
  public user: any = null;
  public state :any = "nothing";
  private currentUserSubject: BehaviorSubject<user>;
  public currentUser: Observable<user>;

  constructor(private http: HttpClient, private router: Router) {
    // Restaurer l'état d'authentification depuis sessionStorage au démarrage
    const storedUser = typeof sessionStorage !== 'undefined' ? JSON.parse(sessionStorage.getItem('currentUser') || 'null') : null;
    const storedToken = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('token') : null;
    if (storedUser && storedToken) {
      this.user = storedUser;
      this.token = storedToken;
    }
    this.currentUserSubject = new BehaviorSubject<user>(storedUser);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): user {
    return this.currentUserSubject.value;
  }

  verify() { // todo: remove this and verify from server

    this.state = "verifying";
     let user = JSON.parse(sessionStorage.getItem('currentUser'));
     let token = sessionStorage.getItem('token') || this.token;
     return this.http.post<any>(`${environment.apiUrl}/auth/refresh`, { username: user?.username, email:user?.email, token: token })
       .pipe(map(res => {
         // store user details and jwt token in local storage to keep user logged in between page refreshes
         sessionStorage.setItem('currentUser', JSON.stringify(res.user));
         sessionStorage.setItem('token', res.token);
         this.currentUserSubject.next(res.user);
         this.user = res.user;
         this.token = res.token;
         this.state = "verifyed";
         console.log('verify',this.user, this.token)
         return res;
       }))  ;
   }
   verifyExist(username) { // todo: remove this and verify from server
    return this.http.post<any>(`${environment.apiUrl}/auth/verify`, { username,email:username })
      .pipe(map(res => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        console.log(res)

        return res;
      }));
   }
  login(username: string, password: string) {
    return this.http.post<any>(`${environment.apiUrl}/login`, { username, password })
      .pipe(map(res => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        sessionStorage.setItem('currentUser', JSON.stringify(res.user));
        sessionStorage.setItem('token', res.token);
        this.currentUserSubject.next(res.user);
        this.user = res.user;
        this.token = res.token;
        console.log('login',this.user, this.token)
        return res;
      }));
  }
  loginInOldSite(username: string, password: string) {
    return this.http.post<any>(`${environment.cllajUrl}/login_ajax.php`, { email:username, password }, {withCredentials :true})
      .pipe(map(res => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        // sessionStorage.setItem('currentUser', JSON.stringify(res.user));
        // sessionStorage.setItem('token', res.token);
        // this.currentUserSubject.next(res.user);
        // this.user = res.user;
        // this.token = res.token;
        // console.log('login',this.user, this.token)
        return res;
      }));
  }

  logout() {
    // remove user from local storage to log user out
    sessionStorage.removeItem('currentUser');
    sessionStorage.removeItem('selectedClient')
    sessionStorage.removeItem('token');
    this.currentUserSubject.next(null);
    this.user = null;
    this.token = null;
    this.router.navigate(['/login'])
    setTimeout(()=>{
      sessionStorage.removeItem('currentUser');
      sessionStorage.removeItem('selectedClient')
      sessionStorage.removeItem('token');
      this.currentUserSubject.next(null);
      this.user = null;
      this.token = null;
    },1000)
  }
  signin(username: string) {
    return this.http.post<any>(`${environment.apiUrl}/signin`, { username,email:username })
      .pipe(map(res => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        console.log(res)

        return res;
      }));
  }
  verifySigninCode(code: string) {
    return this.http.post<any>(`${environment.apiUrl}/signincode`, { code })
      .pipe(map(res => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        console.log(res)

        return res;
      }));
  }
  resetPassword(newPassword: string,token:string) {
    return this.http.post<any>(`${environment.apiUrl}/resetpassword`, { newPassword,token })
      .pipe(map(res => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        console.log(res)

        return res;
      }));
  }
  verifyResetPassword(username: string) {
    return this.http.post<any>(`${environment.apiUrl}/verifyresetpassword`, { username })
      .pipe(map(res => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        console.log(res)

        return res;
      }));
  }

  // Account activation methods
  sendActivationEmail(username: string) {
    return this.http.post<any>(`${environment.apiUrl}/sendactivationemail`, { username })
      .pipe(map(res => {
        console.log('sendActivationEmail', res);
        return res;
      }));
  }

  verifyActivationToken(token: string) {
    return this.http.post<any>(`${environment.apiUrl}/verifyactivationtoken`, { token })
      .pipe(map(res => {
        console.log('verifyActivationToken', res);
        return res;
      }));
  }

  activateAccount(token: string, sendConfirmationEmail: boolean = false) {
    return this.http.post<any>(`${environment.apiUrl}/activateaccount`, { token, sendConfirmationEmail })
      .pipe(map(res => {
        console.log('activateAccount', res);
        // If activation returns token and user, log them in automatically
        if (res.token && res.user) {
          sessionStorage.setItem('currentUser', JSON.stringify(res.user));
          sessionStorage.setItem('token', res.token);
          this.currentUserSubject.next(res.user);
          this.user = res.user;
          this.token = res.token;
        }
        return res;
      }));
  }

  getImpersonationUsers() {
    return this.http.get<any>(`${environment.apiUrl}/auth/impersonation/users`)
      .pipe(map(res => {
        console.log('Impersonation users', res)
        return res;
      }));
  }

}
